import React from 'react';
import PropTypes from 'prop-types';

function SticksBackground({ color }) {
  return (
    <>
      <path
        d="M279.026 290.445C264.167 290.445 249.918 296.348 239.411 306.855C228.904 317.361 223.002 331.612 223.002 346.47C223.002 361.328 228.904 375.579 239.411 386.085C249.918 396.592 264.167 402.495 279.026 402.495C293.885 402.495 308.135 396.592 318.641 386.085C329.148 375.579 335.051 361.328 335.051 346.47C335.051 331.612 329.148 317.361 318.641 306.855C308.135 296.348 293.885 290.445 279.026 290.445ZM520.205 291.138C505.347 291.138 491.096 297.041 480.59 307.547C470.083 318.054 464.18 332.304 464.18 347.163C464.18 362.021 470.083 376.271 480.59 386.778C491.096 397.285 505.347 403.187 520.205 403.187C535.063 403.187 549.314 397.285 559.82 386.778C570.327 376.271 576.23 362.021 576.23 347.163C576.23 332.304 570.327 318.054 559.82 307.547C549.314 297.041 535.063 291.138 520.205 291.138Z"
        fill={color}
      />
      <path
        d="M279.025 297.887C251.841 297.887 229.749 319.979 229.749 347.163C229.749 374.347 251.841 396.439 279.025 396.439C306.209 396.439 328.301 374.347 328.301 347.163C328.301 319.979 306.209 297.887 279.025 297.887Z"
        fill="#0F1113"
      />
      <path
        d="M520.205 297.887C493.021 297.887 470.929 319.979 470.929 347.163C470.929 374.347 493.021 396.439 520.205 396.439C547.389 396.439 569.481 374.347 569.481 347.163C569.481 319.979 547.389 297.887 520.205 297.887Z"
        fill="#0F1113"
      />
    </>
  );
}

SticksBackground.propTypes = {
  color: PropTypes.string,
};

SticksBackground.defaultProps = {
  color: '#20232E',
};

export default SticksBackground;
